import { useState, useEffect, useCallback, useMemo } from "react";
import { useUserApi } from "../../hooks/useUserApi";

export const useAllUsersViewModel = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getUsers } = useUserApi();

  const fetchUsers = useCallback(async () => {
    if (!loading) setLoading(true);
    try {
      const result = await getUsers();
      if (result.success) {
        setUsers(result.data);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [getUsers]);

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    loading: loading,
    error,
    refetch: fetchUsers,
  };
};
